import React from 'react';
import SearchBar from '../Search/SearchBar';

const SearchGeneric = () => {
  return (
    <SearchBar
      placeholder="Search for music, artists, playlists..."
      size="medium"
      showSuggestions={true}
      maxSuggestions={6}
    />
  );
};

export default SearchGeneric;